import React, { useEffect, useState, useCallback } from 'react';
import { Column, Columns } from '@codeparva/ui-components-library';
import { AccountPanelTypes } from '../../AccountPanelTypes';
// import {
//   getDecimalBalance,
//   getNextBillingDate,
// } from '../../helpers/accountPanelHelper';
import {
  amountResolutionType,
  currentBalanceNotAvailable,
  // currentBalanceNotAvailable,
  // estimatedNewChargesNotAvailable,
  // nextBillingDateNotAvailable,
} from '../../constants/accountPanelConfigs';
import { billingDetailsLabels } from '../../constants/accountPanelConfigs';
import { Text } from '../../../../components/textVariations';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import ReactTooltip from 'react-tooltip';
import {
  getAmountToPay,
  getLedgerBalance,
  getUpdatedAmount,
} from '../../../rentalPage/helpers/paymentComponentHelper';
import { debounce } from './../../../../utilities/utils';
import { getDecimalBalance } from '../../helpers/accountPanelHelper';
import { isValidObject } from '../../../../utilities/objectHelper';

export const BillingDetails = ({
  new_balance,
  chargeType,
  facility_id,
  customAmount,
  charge_amount,
  setCustomAmount,
  amountResolution,
  customAmountError,
  setAmountResolution,
  current_balance_due,
  isPrepaymentAllowed,
  isPartialPaymentAllowed,
  parentChargeDetailsUpdater,
  preferred_payment_method_id,
  isCardPaymentTypeChanges,
  tenantToken,
}: // estimated_new_charges,
// next_billing_data,
AccountPanelTypes.TBillingDetailsProp) => {
  const _getLedgerBalance = (allowNegativeAmount = false) =>
    getLedgerBalance(current_balance_due, allowNegativeAmount);
  const _getAmountToPay = () => {
    if (customAmountError?.current) {
      return getDecimalBalance(customAmount);
    }
    if (amountResolution === amountResolutionType.balanceAmount) {
      const updated_current_balance_due = _getLedgerBalance();
      return Number(updated_current_balance_due) <= 0
        ? currentBalanceNotAvailable
        : getAmountToPay({
            current_balance_due,
            new_balance: updated_current_balance_due,
          });
    }
    if (amountResolution === amountResolutionType.customAmount) {
      return String(customAmount);
    }
    return getAmountToPay({ current_balance_due, new_balance });
  };
  const _getTotalAmountToPay = () => {
    if (charge_amount) {
      return Number(_getAmountToPay()) + Number(charge_amount);
    }
    return Number(_getAmountToPay());
  };

  const [isLoading, setIsLoading] = useState(false);

  // const billing_Date = getNextBillingDate(next_billing_data);
  const {
    balance,
    // billingDate,
    // newCharges,
    sectionLabel,
  } = billingDetailsLabels;
  // const decimalBalance = getDecimalBalance(current_balance_due);
  // const decimalEstimatedCharges = estimated_new_charges
  //   ? getDecimalBalance(estimated_new_charges)
  //   : '';

  const validateCustomAmount = (newValue: string) => {
    const validDecimal = /^\d+(\.\d{1,2})?$/;

    if (!validDecimal.test(newValue))
      return 'Please enter a valid amount.Ensure amount is not more than two decimal places';

    if (Number(newValue) <= 0)
      return 'Ensure amount can not be lesser than or equal to zero';

    if (Number(newValue) > Number(current_balance_due) && !isPrepaymentAllowed)
      return 'Entered amount can not be greater than due balance';

    if (
      Number(newValue) < Number(current_balance_due) &&
      !isPartialPaymentAllowed
    )
      return 'Entered amount can not be lesser than due balance';

    return '';
  };

  const onBlur = (event: any) => {
    const newValue = event.target.value;
    setCustomAmount(newValue);
    if (isValidObject(customAmountError)) {
      customAmountError.current = validateCustomAmount(newValue);
    }
  };

  const onChangeAmountResolution = (value: string) => {
    setAmountResolution(value);
  };

  const onChangeCustomAmount = (event: any) => {
    const newValue = event.target.value;
    if (isValidObject(customAmountError)) {
      customAmountError.current = validateCustomAmount(newValue);
    }
    setCustomAmount(newValue);
  };

  const fetchNewCharges = useCallback(
    debounce(async (amount: string, paymentMethodId: string) => {
      setIsLoading(true);
      const response = await getUpdatedAmount(
        paymentMethodId,
        amount,
        facility_id,
        tenantToken
      );
      if (parentChargeDetailsUpdater)
        parentChargeDetailsUpdater({
          amount: response.amount,
          charge_amount: response.surcharge_or_discount,
          chargeType: response.modifier,
          amount_without_modifer: response.amount_without_modifier,
        });
      setIsLoading(false);
    }),
    []
  );

  useEffect(() => {
    if (
      Number(customAmount) > 0 &&
      preferred_payment_method_id &&
      !customAmountError?.current
    ) {
      fetchNewCharges(customAmount, preferred_payment_method_id);
    }
  }, [
    getDecimalBalance(customAmount),
    preferred_payment_method_id,
    isCardPaymentTypeChanges,
  ]);

  return (
    <div className="billingDetailsContentContainer">
      <div className="billingSectionTitle">
        <h5>{sectionLabel}</h5>
      </div>
      <div className="cardBillingDetails">
        <Columns marginless className="billingDetailsSection">
          {/* <Column className="singleBillSection">
            <Text>{newCharges}</Text>
            <Text className="has-text-weight-bold">
              $<span></span>
              {estimated_new_charges
                ? decimalEstimatedCharges
                : estimatedNewChargesNotAvailable}
            </Text>
          </Column>
          <Column className="singleBillSection">
            <Text>{billingDate}</Text>
            <Text className="has-text-weight-bold">
              {billing_Date ? billing_Date : nextBillingDateNotAvailable}
            </Text>
          </Column> */}
          {isPrepaymentAllowed || isPartialPaymentAllowed ? (
            <>
              <div className="billingSectionTitle">
                <p className="pt-5 pb-2">Amount</p>
              </div>
              <Column className="amountSection">
                <div
                  className="existingCardCheckbox amountRadio"
                  onClick={() =>
                    onChangeAmountResolution(amountResolutionType.balanceAmount)
                  }
                  data-testid="use-existing-checkbox"
                >
                  <input
                    type="radio"
                    value={amountResolutionType.balanceAmount}
                    checked={
                      amountResolution === amountResolutionType.balanceAmount
                    }
                  />
                  <span className="radio-label">
                    Balance Amount (${_getLedgerBalance(true)})
                  </span>
                </div>
                <div className="otherAmountSection">
                  <div className="customAmountSection">
                    <div
                      className="existingCardCheckbox amountRadio"
                      onClick={() =>
                        onChangeAmountResolution(
                          amountResolutionType.customAmount
                        )
                      }
                      data-testid="use-existing-checkbox"
                    >
                      <input
                        type="radio"
                        value={amountResolutionType.customAmount}
                        checked={
                          amountResolution === amountResolutionType.customAmount
                        }
                      />
                      <span className="radio-label">Other Amount</span>
                    </div>
                    {amountResolution === amountResolutionType.customAmount && (
                      <div className="customAmountInputWrapper">
                        <div className="customAmount">
                          <span className="currency-code">$</span>
                          <input
                            type="number"
                            onBlur={onBlur}
                            value={customAmount}
                            className="customAmountInput"
                            onChange={onChangeCustomAmount}
                          />
                        </div>
                        {isLoading && (
                          <div className="overlay">
                            <div className="loader"></div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {customAmountError?.current && (
                    <Text className="errorText">
                      {customAmountError?.current}
                    </Text>
                  )}
                </div>
              </Column>
            </>
          ) : (
            <Column className="singleBillSection">
              <Text>{balance}</Text>
              <Text className="has-text-weight-bold">
                $<span></span>
                {_getLedgerBalance()}
              </Text>
            </Column>
          )}
          <Column className="totalBillSection">
            <Text>
              <span className="subtitle1">Total Payable Amount</span>
              {new_balance ? (
                <>
                  <span
                    data-tip
                    data-for="accountSplitUpTip"
                    className="pl-2 has-text-primary"
                  >
                    <FontAwesomeIcon
                      iconClassName="FaInfoCircle"
                      iconContextProps={{
                        className: 'has-text-primary',
                      }}
                    />
                  </span>
                  {new_balance ? (
                    <ReactTooltip
                      className="accountSplitUpTipClass"
                      id="accountSplitUpTip"
                      type="light"
                      effect="solid"
                      backgroundColor="white"
                      getContent={function() {
                        return (
                          <>
                            <p className="accountSplitUpTipPara">
                              Account Split Up
                            </p>
                            <ul className="accountSplitUpTipList">
                              <li>Payment Amount: ${_getAmountToPay()}</li>
                              {chargeType && charge_amount ? (
                                <li>
                                  {chargeType}: ${charge_amount}
                                </li>
                              ) : (
                                <></>
                              )}
                              <li>
                                Total Payable Amount: $
                                {_getTotalAmountToPay().toFixed(2)}
                              </li>
                            </ul>
                          </>
                        );
                      }}
                    ></ReactTooltip>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
            </Text>
            <Text className="has-text-weight-bold amount_due_section">
              $<span></span>
              {_getTotalAmountToPay().toFixed(2)}
            </Text>
          </Column>
        </Columns>
      </div>
    </div>
  );
};
